import { UIRouterModule } from '@uirouter/angular';
import * as fromRegistration from '.';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild({
            // TODO: will having all these here mess with lazy loading of modules?
            // https://ui-router.github.io/guide/lazyloading
            states: [
                {
                    // name: 'efcheckup.**',
                    name: 'register',
                    url: '/register',
                    // loadChildren: () => import('./checkup.module').then(r => r.CheckupModule),
                    data: { requiresAuth: true },
                    component: fromRegistration.RegistrationContainerComponent
                }
            ]
        })
    ]
})
export class RegistrationRouteModule {}
